// extracted by mini-css-extract-plugin
export default {"video":"T7siS","details":"MrNFY","caption":"hSIwE","duration":"t4Wk8","durationIcon":"gt6AI","buttons":"kx8UW"};